import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationalInboundMessageTriggers } from "./constants";
import type { ConversationalInboundMessageTriggersResult } from "./types";
import { isConversationalInboundMessageTriggersResult } from "./validators";

/**
 * With no `subscriptionGroupIds` the endpoint returns every agent-enabled subscription group; with some it
 * returns just those groups, whether or not an agent is enabled on them yet.
 */
export const getConversationalInboundMessageTriggers = reactQueryFetcherAdapter(
  conversationalInboundMessageTriggers,
  (
    signal: AbortSignal,
    appGroupId: string,
    subscriptionGroupIds: string[]
  ): Promise<ConversationalInboundMessageTriggersResult> => {
    const params = subscriptionGroupIds.length > 0 ? { subscription_group_ids: subscriptionGroupIds } : {};
    return fetch(`/${appGroupId}/conversational/inbound_message_triggers`, "GET", params, { signal });
  },
  isConversationalInboundMessageTriggersResult
);
